var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHamburger = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.509 8.796H1.93c-.798 0-1.451.653-1.451 1.451 0 .799.653 1.452 1.451 1.452H19.51c.798 0 1.451-.653 1.451-1.452 0-.798-.639-1.451-1.451-1.451Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.931 2.903H19.51c.798 0 1.451-.653 1.451-1.452C20.96.653 20.307 0 19.509 0H1.93C1.133 0 .48.653.48 1.451c0 .799.653 1.452 1.451 1.452Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.509 17.577H1.93c-.798 0-1.451.653-1.451 1.452 0 .798.653 1.451 1.451 1.451H19.51c.798 0 1.451-.653 1.451-1.451 0-.799-.639-1.452-1.451-1.452Z",
    fill: "currentColor"
  })));
};
export { SvgHamburger as ReactComponent };